<template>
  <li class="tour-row" data-testid="timeline-tour">
    <a v-affiliate-link
      :href="tour.url"
      target="_blank"
      rel="noopener sponsored"
      class="tour-row-link"
      :title="tour.title"
    >{{ tour.title }}</a>
    <span v-if="tour.price" class="tour-row-price">From {{ tour.price }}</span>
  </li>
</template>

<script>
/**
 * CP-160 / CP-214: compact tour row. The title is the link (full title in the
 * link's title attribute); no separate per-tour call-to-action label. Price
 * sits right-aligned. At phone width the row is one line and the title truncates.
 * ExcursionCard stays the full-size version of the same experience.
 */
export default {
  name: 'TourRow',
  props: {
    tour: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.tour-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  min-height: 36px;
  padding: 6px 0;
  border-bottom: 1px solid var(--color-border-light, #e8eeef);
  font-size: 14px;
  line-height: 1.35;
}

.tour-row:last-child {
  border-bottom: 0;
}

.tour-row-link {
  min-width: 0;
  color: var(--color-text);
  text-decoration: underline;
  text-decoration-color: var(--color-border);
  text-underline-offset: 3px;
}

.tour-row-link:hover,
.tour-row-link:focus-visible {
  text-decoration-color: currentColor;
}

.tour-row-price {
  flex: none;
  font-weight: 700;
  white-space: nowrap;
  color: var(--color-text);
}

@media (max-width: 767px) {
  .tour-row {
    min-height: 44px;
    align-items: center;
    gap: 12px;
  }

  .tour-row-link {
    flex: 1 1 auto;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
